import {
  CalendarIcon,
  RackIcon,
  KeyIcon,
  UserIcon,
  NoteIcon,
  ReceiptIcon,
  DisplayIcon,
  ChartDollarIcon,
  HotelIcon,
  CoinIcon,
  FolderIcon,
  TicketIcon,
  ShoppingCartIcon,
  ShieldIcon,
  CustomerServicesIcon,
  QrCodeIcon,
  EmployeeIcon,
  FoodIcon,
  Hotel2Icon,
  DataBaseIcon,
  ClockIcon,
} from "components/Icons";

import DeliveryPanel from "apps/DeliveryPanel/DeliveryPanel";
import SaleOrder from "apps/SaleOrder/SaleOrder";
import PurchaseOrder from "apps/PurchaseOrder/PurchaseOrder";
import StockRequest from "apps/StockRequest/StockRequest";
import StockRequestQr from "apps/StockRequest2/StockRequest";
import PurchaseApproval from "apps/PurchaseApproval/PurchaseApproval";
import Schedule from "apps/Surveillance/Schedule";
import Inventory from "apps/Inventory/Inventory";
import SaleCallCenter from "apps/SaleCallCenter/SaleCallCenter";
import HotelCalendar from "apps/HotelCalendar/RateCalendar";
import HotelRack from "apps/HotelRack/Rack";
import TakeOrder from "apps/TakingOrder/TakeOrder";
import OrderViewer from "apps/OrderViewer/OrderViewer";
import Requisition from "apps/PurchaseRequisition/PurchaseRequisition";

import Housekeeping from "apps/Housekeeping/Housekeeping";
import ServiceHotel from "apps/ServicesHotel/ScreenService";

import RestOrder from "apps/RestOrder/RestOrder";
import WebCheckIn from "ext-apps/WebCheckIn/WebCheckIn";
import ConsultPQR from "ext-apps/ConsultPQR/ConsultPQR";
import SelfServiceSale from "ext-apps/SelfServiceSale/SelfServiceSale";
import SaleTurn from "ext-apps/SaleTurn/SaleTurn";
import Booking from "apps/Booking/ScreenBooking";
import HotelBooking from "apps/HotelBooking/ScreenBooking";
import Activity from "apps/Activity/Activity";
import ScreenRental from "apps/Rental/ScreenRental";
import WebBookingRental from "ext-apps/BookingRental/WebBookingRental";
import SaleAudit from "apps/SaleAudit/SaleAudit";
import Catalog from "apps/Catalog/Catalog";
import Maintenance from "apps/Maintenance/ScreenMaintenance";
import WebBookingHotel from "ext-apps/WebBookingHotel/WebBooking";
import ActivityInformation from "apps/Activity/ActivityInformation";
import AccountStatement from "apps/AccountStatement/Statement";
import SaleTracker from "ext-apps/SaleTracker/SaleTracker";
import WebTickekSystem from "ext-apps/WebTicketSystem/WebTickekSystem";
import RegisterTicketSystem from "ext-apps/RegisterTicketSystem/RegisterTicketSystem";
import TicketSystem from "apps/TicketSystem/TicketSystem";
import SaleGift from "ext-apps/SaleGift/SaleGift";
import ConfirmDelivery from "ext-apps/ConfirmDelivery/ConfirmDelivery";
import ScreenAffiliates from "apps/Affiliates/ScreenAffiliates";
import ScreenQrSale from "apps/QrSale/ScreenQrSale";
import PartyScreen from "apps/Partyv2/PartyScreen";
import ScreenMelhousDash from "apps/Melhous/ScreenMelhous";
import ScreenProspect from "ext-apps/CrmFormProspect/ScreenProspect";
import ScreenConfirm from "ext-apps/Confirm/ScreenConfirm";
import AppointmentCalendar from "apps/AppointmentScheduling/views/AppointmentCalendar";
import HotelFrontdesk from "apps/HotelFrontdesk/FrontdeskScreen";
import StaffShiftSchedule from "apps/StaffShiftSchedule/ShiftSchedule";
import StaffAssistance from "apps/StaffAssistance/StaffAssistance";
import ViewAssistance from "apps/StaffAssistance/views/ViewAssistance";
import ViewAudit from "apps/StaffAssistance/views/ViewAudit";
import ScreenSaleValidation from "apps/SaleValidation/ScreenSaleValidation";
import ScreenSupplies from "apps/StaffSupply/ScreenSupply";
import MainCatalog from "apps/StaffSupply/views/MainCatalog";
import MainIndicators from "apps/StaffSupply/views/MainIndicators";
import MainRequest from "apps/StaffSupply/views/MainRequest";
import AddRequest from "apps/StaffSupply/views/AddRequest";
import WebTra from "ext-apps/WebTra/Index";
import RestOrderTabs from "apps/SaleOrderTabs/RestOrderTabs";
import CompanyIntegration from "apps/CompanyIntegration/FinancialScreen";
import MealStaff from "apps/MealStaff/MealStaff";
import CrmSales from "apps/CRMSales/ScreenCrm";
import ViewProspects from "apps/CRMSales/views/ViewProspects";
import ViewActivities from "apps/CRMSales/views/ViewActivities";
import ViewOpportunity from "apps/CRMSales/views/ViewOpportunity";
import Vps from "apps/Vps/ScreenVps";
// import Production from "apps/Production/Production";
// import ScreenWeighingInterface from "apps/WeighingInterface/ScreenWeighingInterface";
// import OrderNotification from "deprecated/OrderNotification/OrderNotification";
// import TravelPerson from "apps/TravelPerson/TravelPerson";
// import PortalCustomer from "deprecated/PortalCustomer/PortalCustomer";
// import ScreenCrmChart from "apps/CrmChart/ScreenCrmChart";
// import AppointmentSales from "apps/AppointmentScheduling/views/AppointmentSales";
// import AppointmentInvoices from "apps/AppointmentScheduling/views/AppointmentInvoices";
// import AppointmentReports from "apps/AppointmentScheduling/views/AppointmentReports";

const apps = {
  housekeeping: { Component: Housekeeping, Icon: KeyIcon },
  service_hotel: { Component: ServiceHotel, Icon: Hotel2Icon },
  party: { Component: PartyScreen, Icon: UserIcon },
  hotel_rack: {
    Component: HotelRack,
    Icon: RackIcon,
  },
  hotel_frontdesk: {
    Component: HotelFrontdesk,
    Icon: CustomerServicesIcon,
  },
  hotel_calendar: { Component: HotelCalendar, Icon: CalendarIcon },
  web_checkin: {
    Component: WebCheckIn,
    addPath: ":id/*",
  },
  sale_order: { Component: SaleOrder, Icon: NoteIcon },
  // sale_order: {
  //   Component: Production,
  //   Icon: CoinIcon,
  // },
  rest_order_tabs: { Component: RestOrderTabs, Icon: FoodIcon },
  self_service_sale: {
    Component: SelfServiceSale,
    addPath: ":shop",
  },
  delivery: { Component: DeliveryPanel, Icon: ReceiptIcon },
  shipment_internal: { Component: StockRequest, Icon: FolderIcon },
  shipment_internal_qr: { Component: StockRequestQr, Icon: FolderIcon },
  purchase: { Component: PurchaseOrder, Icon: ShoppingCartIcon },
  purchase_approval: { Component: PurchaseApproval, Icon: ShoppingCartIcon },
  surveillance_schedule: { Component: Schedule, Icon: ShieldIcon },
  inventory: { Component: Inventory, Icon: FolderIcon },
  take_order: { Component: TakeOrder, Icon: NoteIcon },
  order_viewer: { Component: OrderViewer, Icon: DisplayIcon },
  sale_call_center: { Component: SaleCallCenter, Icon: NoteIcon },
  purchase_requisition: {
    Component: Requisition,
    Icon: FolderIcon,
  },
  sale_turn: { Component: SaleTurn, Icon: FolderIcon },
  consulta_pqr: { Component: ConsultPQR, Icon: FolderIcon },
  crm_form_prospect: {
    Component: ScreenProspect,
    Icon: ChartDollarIcon,
  },
  // crm_chart: { Component: ScreenCrmChart, Icon: ChartDollarIcon },
  rest_order: { Component: RestOrder, Icon: NoteIcon },
  booking: { Component: Booking, Icon: HotelIcon },
  hotel_booking: { Component: HotelBooking, Icon: HotelIcon },
  activity: { Component: Activity, Icon: FolderIcon },
  activity_information: {
    Component: ActivityInformation,
    Icon: FolderIcon,
  },
  rental: { Component: ScreenRental, Icon: FolderIcon },
  maintenance: { Component: Maintenance, Icon: FolderIcon },
  web_booking_rental: {
    Component: WebBookingRental,
    Icon: FolderIcon,
    addPath: ":id?",
  },
  sale_audit: {
    Component: SaleAudit,
    Icon: FolderIcon,
  },
  catalog: {
    Component: Catalog,
    Icon: FolderIcon,
  },
  web_booking: {
    Component: WebBookingHotel,
    Icon: FolderIcon,
    addPath: ":date?",
  },
  booking_engine: {
    Component: WebBookingHotel,
    addPath: ":date?",
  },
  hotel_tra: {
    Component: WebTra,
    addPath: ":id?",
  },
  dashboard_melhous: {
    Component: ScreenMelhousDash,
    Icon: FolderIcon,
  },
  account_statement: {
    Component: AccountStatement,
    Icon: CoinIcon,
  },
  sale_tracker: {
    Component: SaleTracker,
    addPath: ":id?",
  },
  ticket: {
    Component: TicketSystem,
    Icon: TicketIcon,
  },
  web_ticket_system: {
    Component: WebTickekSystem,
  },
  register_ticket_system: {
    Component: RegisterTicketSystem,
  },
  sale_gift: {
    Component: SaleGift,
    addPath: ":id?",
  },
  sale_confirm_delivery: {
    Component: ConfirmDelivery,
    addPath: ":id?",
  },
  affiliates: {
    Component: ScreenAffiliates,
    Icon: UserIcon,
  },
  qr_sale: {
    Component: ScreenQrSale,
    Icon: UserIcon,
  },
  // attendance_control: {
  //   Component: AttendanceControl,
  //   Icon: UserIcon,
  // },
  confirm: {
    Component: ScreenConfirm,
    Icon: FolderIcon,
    addPath: ":id?",
  },
  appointment_scheduling: {
    Component: AppointmentCalendar,
    Icon: CalendarIcon,
    // children: [
    //   {
    //     key: "sales",
    //     Component: AppointmentSales,
    //     Icon: CalendarIcon,
    //   },
    //   {
    //     key: "invoices",
    //     Component: AppointmentInvoices,
    //     Icon: CalendarIcon,
    //   },
    //   {
    //     key: "reports",
    //     Component: AppointmentReports,
    //     Icon: CalendarIcon,
    //   },
    // ],
  },
  staff_shift_schedule: {
    Component: StaffShiftSchedule,
    Icon: CalendarIcon,
  },
  staff_assistance: {
    Component: StaffAssistance,
    Icon: ClockIcon,
    children: [
      {
        key: "assistance",
        Component: ViewAssistance,
      },
      {
        key: "audit",
        Component: ViewAudit,
      },
    ],
  },
  staff_supply: {
    Component: ScreenSupplies,
    Icon: EmployeeIcon,
    children: [
      {
        key: "request",
        Component: MainRequest,
        Icon: CalendarIcon,
      },
      {
        key: "add_request",
        Component: AddRequest,
        Icon: CalendarIcon,
        visible: true,
      },
      {
        key: "staff_supply_product",
        Component: MainCatalog,
        Icon: CalendarIcon,
      },
      {
        key: "staff_supply_indicators",
        Component: MainIndicators,
        Icon: CalendarIcon,
      },
    ],
  },
  sale_validation: { Component: ScreenSaleValidation, Icon: QrCodeIcon },
  company_integration_financial: {
    Component: CompanyIntegration,
    Icon: CoinIcon,
  },
  staff_meal: { Component: MealStaff, Icon: FoodIcon },
  crm_sales: {
    Component: CrmSales,
    Icon: ChartDollarIcon,
    children: [
      {
        key: "opportunity",
        Component: ViewOpportunity,
        Icon: CalendarIcon,
      },
      {
        key: "prospect",
        Component: ViewProspects,
        Icon: CalendarIcon,
      },
      {
        key: "activity",
        Component: ViewActivities,
        Icon: CalendarIcon,
      },
    ],
  },
  vps: { Component: Vps, Icon: DataBaseIcon },

  hotel_tra: {
    Component: WebTra,
    addPath: ":id?/:request?",
  },
};

export default apps;
